import styled from 'styled-components';

/** Section wrapper — matches homepage white / light gray rhythm */
const Section = styled.section`
  padding: ${(p) => p.$padding || '96px 0'};
  position: relative;
  background: ${(p) => {
    if (p.$alt) return '#f7fafc';
    if (p.$mint) return '#fafbfc';
    return '#fff';
  }};
`;

export default Section;
